import { Button, Modal, Form, Input, message } from "antd";
import API from "../../../../services/api-request";
import SelectRFID from "../../../../components/SelectRFID";
import SelectTypePallet from "../../../../components/SelectTypePallet";

const AddPallet = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { name, rfid_id, type } = values;

    const dataForm = {
      name,
      rfid_id,
      type,
    };

    await API.Post("pallet", dataForm)
      .then(() => {
        message.success("Pallet has been added");
        props.onGetPallet();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Pallet"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="No. RFID"
            name="rfid_id"
            rules={[{ required: true, message: "Please input No. RFID!" }]}
          >
            <SelectRFID isAvailable={true} />
          </Form.Item>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input placeholder="Input Name" />
          </Form.Item>
          <Form.Item
            label="Tipe Pallet"
            name="type"
            rules={[{ required: true, message: "Please input Tipe Pak!" }]}
          >
            <SelectTypePallet />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddPallet;
